module.exports = __webpack_public_path__ + "img/tour-21.149f0b02.png";